import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation removePlaidAccountMutation($input: RemovePlaidAccountInput!) {
    removePlaidAccount(input: $input) {
      errorMessage
      successMessage
    }
  }
`;

const removePlaidAccount = (environment, integrationItemId, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: {
        integrationItemId,
      },
    },
    ...args,
  });
};

export default removePlaidAccount;
